<template>
  <el-dialog title="创建订单" :visible.sync="visible" width="1100px" :closeOnClickModal="false" :before-close="close" custom-class="create-order">
    <el-form class="create-order-form" ref="orderForm" :model="form" label-width="80px" :rules="form.requiresShipping?rules:{}">
      <div class="title">基础信息</div>
        <el-form-item label-width="160px" label="是否发货" prop="sampleFee">
          <el-radio v-model="form.requiresShipping" :label="true" @input="handleRadio">是</el-radio>
          <el-radio v-model="form.requiresShipping" :label="false" @input="handleRadio">否</el-radio>
        </el-form-item>
      <div class="title">收货地址信息</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="160px" label="Full Name" prop="orderAddresses.recipient">
            <el-input v-model="form.orderAddresses.recipient" placeholder="Full Name" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="160px" label="Phone Number" prop="orderAddresses.phone">
            <el-input v-model="form.orderAddresses.phone" placeholder="Phone Number" size="small">
              <el-select v-model="areaCode" filterable slot="prepend" style="color:000;width:100px" @change="handleAreaCodeChange">
                <el-option v-for="item in addressDataFilter" :label="item.areaCode" :value="item.countryCode+item.areaCode" :key="item.countryCode+item.areaCode">{{item.areaCode}}({{ item.countryCode }})</el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="160px" label="Street Address Line1" prop="orderAddresses.street1">
        <el-input v-model="form.orderAddresses.street1" placeholder="Street Address Line1" size="small"></el-input>
      </el-form-item>
      <el-form-item label-width="160px" label="Street Address Line2" prop="orderAddresses.street2">
        <el-input v-model="form.orderAddresses.street2" placeholder="Street Address Line2" size="small"></el-input>
      </el-form-item>
      <el-row :gutter="20" class="f-b-c">
        <el-col :span="12">
          <el-form-item label-width="160px" label="Country/Region" prop="orderAddresses.country">
            <el-select v-model="form.orderAddresses.country" placeholder="Country/Region" filterable style="width:100%" @change="handleCountryChange" :filter-method="value=> countryFilterMethod(value)">
              <el-option v-for="item in addressDataFilter" :key="item.countryCode" :label="item.countryNameEn" :value="item.countryCode">{{item.countryNameEn}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="160px" label="State/Provice/Region" prop="orderAddresses.province">
            <el-input v-model="form.orderAddresses.province" placeholder="State/Provice/Region" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="f-b-c">
        <el-col :span="12">
          <el-form-item label-width="160px" label="City" prop="orderAddresses.city">
            <el-input v-model="form.orderAddresses.city" placeholder="City"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="160px" label="Zip Code" prop="orderAddresses.zip">
            <el-input v-model="form.orderAddresses.zip" placeholder="Zip Code"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title">商品信息</div>
      <el-table :data="goodsList" max-height="420">
        <el-table-column label="SKU" width="220">
          <template slot-scope="{row}">
            <el-input v-model="row.skuCode" placeholder="skuCode" @blur="getProductSkuInfo(row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="产品标题" width="210">
          <template slot-scope="{row}">
            <span>{{ row.productName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售单价($)" width="160">
          <template slot-scope="{row}">
            <el-input-number v-model="row.price" :precision="2" :min="0" :max="10000" controls-position="right" style="width:140px" @change="change(row, 'price')"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="销售数量" width="160">
          <template slot-scope="{row}">
            <el-input-number v-model="row.productNum" :precision="0" :min="0" :max="10000" controls-position="right" style="width:140px" @change="change(row, 'productNum')"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="销售金额($)" width="180">
          <template slot-scope="{row}">
            <el-input v-model="row.totalPrice" placeholder="销售金额" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="{$index}">
            <el-button type="text" @click="handleGoods('add', $index)">新增</el-button>
            <el-button v-if="goodsList.length > 1" type="text" style="color:#f56c6c" @click="handleGoods('del', $index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="title" style="margin-top:20px">金额信息</div>
      <el-form-item label-width="160px" label="收款金额" prop="finalAmount">
        <el-input v-model="form.finalAmount" placeholder="收款金额" size="small" style="width:240px" disabled></el-input>
      </el-form-item>
      <div class="title">备注</div>
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="form.remark"
        show-word-limit
        style="padding-left:30px"
      >
      </el-input>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="affirm">确 定</el-button>
    </span>

    <el-dialog
      title="取消订单"
      :visible.sync="refund.visible"
      width="600px"
      top="20%"
      append-to-body
      :before-close="refundClose"
      custom-class="refund-dialog">
      <div class="hint">一个定制申请只能关联一笔待付款订单；</div>
      <div class="hint" style="padding-bottom: 20px;">您确定要取消{{ refund.kkOrderId }}待付款订单后重新创建新订单？</div>

      <div class="f--c" style="margin-bottom:10px">
        <div class="label">取消原因：</div>
        <el-select v-model="refund.type" size="small" placeholder="请选择原因" style="width:380px">
          <el-option v-for="item in causeList" :key="item.code" :value="item.code" :label="item.name"></el-option>
        </el-select>
      </div>
      <div class="f">
        <div class="label" style="padding-top:6px">备注：</div>
        <el-input v-model="refund.remark" size="small" type="textarea" :rows="3" placeholder="请输入备注" style="width:380px"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundClose">取 消</el-button>
        <el-button type="primary" @click="refundAffirm">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { telephoneNumber, generalPhoneNumber, isValidPostalCode } from '@/utils/validate'
let checktelephoneNumber = (rules, value, callback) => {
  // if (telephoneNumber(value)) {
  if (telephoneNumber(value) || generalPhoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}
export default {
  data() {
    return {
      visible: false,
      form: {
        orderAddresses: {},
        orderItems: []
      },
      rowData: {},
      rules: {
        'orderAddresses.recipient': [{ required: true, message: 'Fullname is Required', trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        'orderAddresses.phone': [{ required: true, message: 'Phone Number is Required', trigger: 'blur' }, { validator: checktelephoneNumber, trigger: 'blur' }, { max: 20, message: 'Please Enter No More Than 20 Characters' }],
        'orderAddresses.street1': [{ required: true, message: 'Street Address Line is Required', trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        'orderAddresses.street2': [{ max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        'orderAddresses.country': [{ required: true, message: 'Country is Required', trigger: 'blur' }],
        'orderAddresses.province': [{ required: false, message: 'Province is Required', trigger: 'blur' }, { max: 100, trigger: 'change', message: 'Please Enter No More Than 100 Characters' }],
        'orderAddresses.city': [{ required: true, message: 'City is Required', trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        'orderAddresses.zip': [{ required: true, message: 'Zip is Required', trigger: 'blur' }, { max: 20, message: 'Please Enter No More Than 20 Characters' }, { validator: this.checkisValidPostalCode, trigger: 'blur' }]
      },
      areaCode: 'US+1',
      addressData: [],
      addressDataFilter: [],
      goodsList: [],
      causeList: [],
      refund: {
        visible: false,
        type: undefined,
        remark: '',
        kkOrderId: ''
      }
    }
  },
  created() {
    this.getSystemAddress()
    this.getPublicSelectData()
  },
  methods: {
    show(row) {
      this.rowData = row
      this.goodsList = [{
        skuCode: undefined,
        productName: '',
        productNum: 0,
        price: 0,
        totalPrice: 0
      }]
      this.form = {
        id: row.id,
        customOrderId: row.demandNo,
        userId: row.userId,
        userName: row.userName,
        requiresShipping: true,
        orderAddresses: {},
        orderItems: []
      }
      this.visible = true
    },
    close() {
      this.$refs.orderForm.clearValidate()
      this.visible = false
    },
    checkisValidPostalCode(rules, value, callback) {
      if (isValidPostalCode(value, this.form.orderAddresses.country)) {
        callback()
      } else {
        callback(new Error('Please enter your valid zipcode'))
      }
    },
    handleRadio() {
      this.$nextTick(() => {
        this.$refs.orderForm.clearValidate()
      })
    },

    // 获取地址
    getSystemAddress() {
      API.getSystemAddress().then(res => {
        this.addressData = res.data
        this.addressDataFilter = this.addressData.slice()
      })
    },
    // 获取商品系统sku信息
    getProductSkuInfo(row) {
      if (this.goodsList.filter(t => t.skuCode === row.skuCode).length>1) {
        this.$message.warning('SKU不能重复')
        this.$set(row, 'productName', '')
        return
      }

      API.getProductSkuInfo({ skuCode: row.skuCode }).then(res => {
        if (res.code !== 10000) {
          this.$message.error(res.message)
          this.$set(row, 'productName', '')
          return
        }
        if (!res.data.skuName) {
          this.$message.warning('该sku未维护产品标题,请到商品系统维护')
        }
        this.$set(row, 'productName', res.data.skuName)
        this.$set(row, 'weight', res.data.weight)
        this.$set(row, 'option1', res.data.option1)
        this.$set(row, 'option2', res.data.option2)
        this.$set(row, 'option3', res.data.option3)
        this.$set(row, 'imageUrl', res.data.mainPath)
      })
    },

    // 切换区号
    handleAreaCodeChange(value) {
      if (value && value.includes('+')) {
        let area = value.split('+')
        this.areaCode = '+'+area[1]
        this.$set(this.form.orderAddresses, 'country', area[0])
      }
    },
    handleCountryChange(value) {
      if (this.form.orderAddresses.country) {
        this.$set(this.form.orderAddresses, 'province', undefined)
      }
      this.getRegios(value)
    },
    getRegios(value) {
      if (!value) return
      this.addressData.forEach(item => {
        // 同时切换国家编码
        if (item.countryCode === value) {
          this.areaCode = item.countryCode + item.areaCode
        }
      })
    },
    countryFilterMethod(searchValue) {
      if (!searchValue) {
        this.addressDataFilter = this.addressData.slice()
      } else {
        const codeArr = []
        const nameArr = []
        this.addressData.forEach(e => {
          if (e.countryCode.includes(searchValue.toUpperCase())) {
            codeArr.push(e)
          } else if (e.countryNameEn.toUpperCase().includes(searchValue.toUpperCase())) {
            nameArr.push(e)
          } else if (searchValue.toUpperCase() === 'UK' && e.countryNameEn.toUpperCase().includes('ENGLAND')) {
            nameArr.push(e)
          }
        })
        this.addressDataFilter = [...codeArr, ...nameArr]
      }
    },

    change(row, type) {
      if (row.price && row.productNum) {
        this.$set(row, 'totalPrice', parseFloat((row.price * row.productNum).toFixed(2)))
        let finalAmount = 0
        this.goodsList.forEach(item => {
          finalAmount += (item.totalPrice || 0)
        })
        this.$set(this.form, 'finalAmount', parseFloat(finalAmount.toFixed(2)))
      }
    },
    handleGoods(type, i) {
      if (type === 'add') {
        this.goodsList.splice(i+1, 0, {
          skuCode: undefined,
          productName: '',
          productNum: 0,
          price: 0,
          totalPrice: 0
        })
      }
      if (type === 'del') {
        this.goodsList.splice(i, 1)
      }
    },

    affirm() {
      this.$refs.orderForm.validate(async (valid) => {
        if (!valid) return false
        if (this.goodsList.some(t => !t.skuCode)) {
          return this.$message.warning('请输入SKU')
        }
        if (this.goodsList.some(t => (t.price == 0 || t.productNum == 0))) {
          return this.$message.warning('销售单价或数量不能小于或等于0')
        }
        if (this.goodsList.some(t => !t.productName)) {
          return this.$message.warning('请输入正确的SKU')
        }

        let form = _.cloneDeep(this.form)
        form.orderAddresses.phone = this.form.orderAddresses.phone ? `+${this.areaCode.split('+')[1]} ${this.form.orderAddresses.phone||''}` : undefined
        form.orderItems = this.goodsList
        API.createCustomOrder(form).then(res => {
          if (res.code === 10402) {
            this.$set(this.refund, 'visible', true)
            this.$set(this.refund, 'kkOrderId', res.message)
            return
          }
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success('订单创建成功')
          this.close()
        })
      })
    },

    getPublicSelectData() {
      API.getPublicSelectData({ type: 5 }).then(res => {
        this.causeList = res.data
      })
    },

    refundClose() {
      this.refund = {
        visible: false,
        type: undefined,
        remark: '',
        kkOrderId: ''
      }
    },
    refundAffirm() {
      const params = new FormData()
      params.append('kkOrderId', this.refund.kkOrderId)
      params.append('operationType', this.refund.type)
      params.append('remark', this.refund.remark)

      API.orderCancel(params).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.refundClose()
        this.affirm()
      })
    }
  }
}
</script>

<style lang="scss">
.create-order {
  .el-dialog__body {
    padding: 20px;
  }
}
.refund-dialog {
  .el-dialog__body {
    padding: 20px;
    padding-top: 6px;
  }
  .hint {
    color: red;
    padding-left: 32px;
  }
  .label {
    flex-shrink: 0;
    width: 100px;
    text-align: right;
  }
}
</style>
<style lang="scss" scoped>
.create-order-form {
  .title {
    font-size: 16px;
    margin: 10px 0;
  }
}
</style>